import { zodTransformFirestoreTimestampToDate } from "../../utils/zodUtils.mjs";
import { zodFlavorId } from "../ids.mjs";
import { defineFirestoreCollection } from "../firebaseCollectionSchema.mjs";
import { executionTraceStampSchema } from "../executionTrace.mjs";
import { bridgePolicyStatusSchema } from "../vendors/bridge/policy.mjs";
import { z as z$1 } from "zod";

// src/models/projections/bridgePatientProjection.ts
const firestoreDate = z$1.any().transform(zodTransformFirestoreTimestampToDate);
/** Fixed doc id under `customers/{customerId}/projections/bridgePatient`. */
const BRIDGE_PATIENT_PROJECTION_KEY = "bridgePatient";
const bridgePatientProjectionConsentSchema = z$1.object({
	/** `null` = capture in progress, L4 doc not observed yet for this type. */
	consentAobId: zodFlavorId().nullable().optional(),
	consentTreatId: zodFlavorId().nullable().optional(),
	consentPrivacyId: zodFlavorId().nullable().optional(),
	consentedAt: firestoreDate.nullable().optional(),
	expiresAt: firestoreDate.nullable().optional()
});
/**
* Lean client gate for Bridge patient + consent wave.
* Path: `customers/{customerId}/projections/bridgePatient`.
*/
const bridgePatientStatusPollOutcomeSchema = z$1.literal("timeout");
const bridgePatientProjectionSchema = z$1.object({
	id: zodFlavorId(),
	patientExists: z$1.boolean(),
	consent: bridgePatientProjectionConsentSchema,
	policyId: zodFlavorId().optional(),
	policyStatus: bridgePolicyStatusSchema.optional(),
	policyValidatedAt: firestoreDate.optional(),
	policyStatusPollOutcome: bridgePatientStatusPollOutcomeSchema.optional(),
	/**
	* True when projection facts match current L3.5 vendor bindings at processing time
	* (every ensure-bound consent id is present in L4 and reflected in `consent`).
	*/
	inSync: z$1.boolean().default(false),
	createdAt: firestoreDate,
	updatedAt: firestoreDate,
	executionTrace: executionTraceStampSchema.optional()
});
const CUSTOMER_PROJECTION_RESOLVE_EVENT_TYPE = "customer_projection.resolve";
const CustomerProjections = defineFirestoreCollection("projections", bridgePatientProjectionSchema, void 0, { executionTrace: true });
/** Pub/Sub ordering key for bridgePatient projection resolve. */
function buildBridgePatientProjectionOrderingKey(customerId) {
	return `customers/${customerId}/projections/${BRIDGE_PATIENT_PROJECTION_KEY}`;
}

export { BRIDGE_PATIENT_PROJECTION_KEY, CUSTOMER_PROJECTION_RESOLVE_EVENT_TYPE, CustomerProjections, bridgePatientProjectionConsentSchema, bridgePatientProjectionSchema, bridgePatientStatusPollOutcomeSchema, buildBridgePatientProjectionOrderingKey };
//# sourceMappingURL=bridgePatientProjection.mjs.map